import React, { Component } from 'react';
import { Icon, Avatar } from '@material-ui/core';
import Downshift from 'downshift';
import './Dropdown.scss';

class Dropdown extends Component {
  message = '';
  skipFirstFocus = true;

  downshift = React.createRef();
  dropdownInput = React.createRef();

  componentDidMount() {
    if (!this.props.noAutofocus && !this.skipFirstFocus) this.dropdownInput.current.focus();
    this.skipFirstFocus = false;
  }

  openDropdown() {
    this.dropdownInput.current.focus();
  }

  clearDropdown() {
    this.downshift.current.clearSelection();
  }

  getInitials(name) {
    let initials = '';
    let nameSplit = name.split(' ');
    if (nameSplit.length < 3) {
      nameSplit.forEach((word) => initials += word[0]);
    } else { // else get first and last letter
      initials += nameSplit[0][0].toUpperCase();
      initials += nameSplit[nameSplit.length - 1][0].toUpperCase();
    }
    return initials;
  }

  selectItem(uid) {
    this.props.selectItem(uid);
    if (this.props.dropdownNum && document.getElementById("downshift-" + this.props.dropdownNum + "-input")) {
      // document.getElementById("downshift-" + this.props.dropdownNum.toString() + "-input").blur();
    }
    if (this.props.clearTextAfterSelect) {
      this.downshift.current.clearSelection();
    }

    this.message = '';

    setTimeout(() => {
      this.dropdownInput.current.focus();
      //this.downshift.openMenu();
    }, 5);
  }

  onKeyDown(e) {
    if (e.keyCode === 8 && this.message.length === 0) {
      this.props.onDelete();
    } else if ((e.keyCode === 13 || e.keyCode === 9) && this.message.length > 0) {
      const items = this.props.items.filter(item => item[this.props.display].toLowerCase().includes(this.message.toLowerCase()));

      if (items.length > 0) {
        if (e.keyCode === 9) {
          e.preventDefault();
          this.selectItem(items[this.downshift.current.state.highlightedIndex || 0].uid);
        } else if (this.downshift.current.state.highlightedIndex === null) {
          this.selectItem(items[0].uid);
        }
      }
    }
  }

  render() {
    const { labelText, items } = this.props;
    return (
      <Downshift
        // ref={(ref) => { this.downshift = ref; }}
        ref={this.downshift}
        itemToString={item => item ? item[this.props.display] : ''}
        onSelect={(user) => user ? this.selectItem(user[this.props.itemKey]) : ''}>
        {({
          getInputProps,
          getItemProps,
          isOpen,
          inputValue,
          highlightedIndex,
          selectedItem,
          clearSelection
        }) => (
          <div className="wrapper" style={{ minWidth: 250, flex: 1, height: 33, zIndex: 10 }}>
            <label className="labelStyle" >{labelText}</label>
            <div className="input">
              <input
                ref={this.dropdownInput}
                id="searchInput"
                placeholder={this.props.placeholder}
                className="emptyInput"
                {...getInputProps({ onKeyDown: this.onKeyDown.bind(this) })}
                onInput={e => {
                  this.message = e.target.value;

                  this.props.items.sort((a, b) => {
                    const aIndex = a.name.toLocaleLowerCase().indexOf(this.message.toLocaleLowerCase());
                    const bIndex = b.name.toLocaleLowerCase().indexOf(this.message.toLocaleLowerCase());

                    if (aIndex === 0 && bIndex !== 0) return -1;
                    else if (aIndex !== 0 && bIndex === 0) return 1;

                    return a.name < b.name ? -1 : (b.name > a.name ? 1 : 0);
                  });
                }}
              />
            </div>
            <div className="clearInputStyle" style={{ visibility: (inputValue.length > 0 ? 'visible' : 'hidden') }}>
              <Icon
                onClick={() => clearSelection(() => this.props.clearSelection()) }
                style={{ marginTop: '-31px', cursor: 'pointer', color: '#6a6a66' }}>
                cancel
              </Icon>
            </div>
            {isOpen ? (
              <div className="dropdown results-wrapper">
                {items
                  .filter(item => item[this.props.display].toLowerCase().includes(inputValue.toLowerCase()))
                  .map((item, index) => (
                    <div
                      key={item}
                      {...getItemProps({
                        key: item[this.props.itemKey],
                        index,
                        item: item,
                        style: { fontWeight: selectedItem === item ? 'bold' : 'normal' }
                      })}
                    >
                      <div className={highlightedIndex === index ? "highlightedRowStyle rowStyle" : "rowStyle"}>
                        {item.photoURL &&
                          <img alt="profile-pic" src={item.photoURL} className="profilePicStyle"></img>
                        }
                        {!item.photoURL &&
                          <Avatar className="initialsAvatar">{this.getInitials(item[this.props.display])}</Avatar>
                        }
                        {item[this.props.display]}
                      </div>
                    </div>
                  ))}
              </div>
            ) : null}
          </div>

        )}
      </Downshift>
    );
  }


}


export { Dropdown };


// WEBPACK FOOTER //
// ./src/components/Dropdown.js